import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
  'draggable-list.dropdown-menu-move-to-top': {
    id: 'draggable-list.dropdown-menu-move-to-top',
    defaultMessage: 'Move to top',
    description:
      'Button label for moving an item to the top of the list in the draggable list dropdown'
  },
  'draggable-list.dropdown-menu-move-up': {
    id: 'draggable-list.dropdown-menu-move-up',
    defaultMessage: 'Move up',
    description:
      'Button label for moving an item up the list in the draggable list dropdown'
  },
  'draggable-list.dropdown-menu-move-down': {
    id: 'draggable-list.dropdown-menu-move-down',
    defaultMessage: 'Move down',
    description:
      'Button label for moving an item down the list in the draggable list dropdown'
  },
  'draggable-list.dropdown-menu-move-to-bottom': {
    id: 'draggable-list.dropdown-menu-move-to-bottom',
    defaultMessage: 'Move to bottom',
    description:
      'Button label for moving an item to the bottom of the list in the draggable list dropdown'
  },
  'draggable-list.drag-handle-label': {
    id: 'draggable-list.drag-handle-label',
    defaultMessage: 'Reorder',
    description: 'The label for the drag handle in the draggable list'
  },
  'draggable-list.delete-item-label': {
    id: 'draggable-list.delete-item-label',
    defaultMessage: 'Delete item: {name}',
    description: 'Label for the delete button in draggable list items'
  }
});
